// This file is auto-generated. Do not edit manually.

import { z } from "zod";

export const EmailTemplateVarsBaseSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
});

export const AppraiserVarsSchema = z.object({
  appraiserIdentifier: z.string(),
  appraiserName: z.string(),
  supportEmail: z.string(),
  appraiserAddress: z.string(),
  appraiserWebsite: z.string(),
  appraiserBrandName: z.string(),
})

export type AppraiserVars = z.infer<typeof AppraiserVarsSchema>;

export const PrePayPaymentEmailTypeEnum = z.enum([
  "no-initial-assessment-prePay-payment-reminder-1",
  "no-initial-assessment-prePay-payment-reminder-2",
  "no-initial-assessment-prePay-payment-reminder-3",
  "no-initial-assessment-prePay-payment-reminder-4",
  "no-initial-assessment-prePay-payment-reminder-5",
]);

export type PrePayPaymentEmailType = z.infer<typeof PrePayPaymentEmailTypeEnum>;

export const PostPayPaymentEmailTypeEnum = z.enum([
  "initial-assessment-postPay-payment-reminder-1",
  "initial-assessment-postPay-payment-reminder-2",
  "initial-assessment-postPay-payment-reminder-3",
  "initial-assessment-postPay-payment-reminder-4",
  "initial-assessment-postPay-payment-reminder-5",
]);

export type PostPayPaymentEmailType = z.infer<typeof PostPayPaymentEmailTypeEnum>;

export const PrePayStandardNoInitialPaymentEmailTypeEnum = z.enum([
  "std-and-no-assessment-prepay-payment-reminder-1",
  "std-and-no-assessment-prepay-payment-reminder-2",
  "std-and-no-assessment-prepay-payment-reminder-3",
  "std-and-no-assessment-prepay-payment-reminder-4",
  "std-and-no-assessment-prepay-payment-reminder-5",
]);

export type PrePayStandardNoInitialPaymentEmailType = z.infer<typeof PrePayStandardNoInitialPaymentEmailTypeEnum>;

export const PrePayInitialPaymentReminderEmailTypeEnum = z.enum([
  "initial-assessment-prepay-payment-reminder-1",
  "initial-assessment-prepay-payment-reminder-2",
  "initial-assessment-prepay-payment-reminder-3",
  "initial-assessment-prepay-payment-reminder-4",
  "initial-assessment-prepay-payment-reminder-5",
]);

export type PrePayInitialPaymentReminderEmailType = z.infer<typeof PrePayInitialPaymentReminderEmailTypeEnum>;

export const PrepayStandardNoInitialVarsSchema = z.object({
  firstName:z.string(),
  lastName:z.string(),
  requestType: z.string(),
  requestId: z.string(),
  propertyAddress:z.string(),
  paymentLink:z.string(),
  isPrepayWithNoAssessment: z.boolean(),
  isStandardPrepay:z.boolean(),
  subject:z.string(),
});

export const PrepayInitialPaymentReminderVarsSchema = z.object({
  firstName:z.string(),
  lastName:z.string(),
  requestType: z.string(),
  requestId: z.string(),
  propertyAddress:z.string(),
  paymentLink:z.string(),
  fileDownloadLink:z.string(),
  cancelRequestOrRemindersLink:z.string(),
});

export const RNDGLiteInitialAssessmentAvailableEmailTypeEnum = z.enum([
"b2c-rndg-lite-initial-assessment-reminder-1",
"b2c-rndg-lite-initial-assessment-reminder-2",
"b2c-rndg-lite-initial-assessment-reminder-3",
"b2c-rndg-lite-initial-assessment-reminder-4",
"b2c-rndg-lite-initial-assessment-reminder-5"
]);

export type RNDGLiteInitialAssessmentAvailableEmailType = z.infer<typeof RNDGLiteInitialAssessmentAvailableEmailTypeEnum
>;

export const RNDGContinuedLitePrepayPaymentRemindersEmailTypeEnum = z.enum([
"b2c-rndg-continued-lite-prepay-payment-reminder-1",
"b2c-rndg-continued-lite-prepay-payment-reminder-2",
"b2c-rndg-continued-lite-prepay-payment-reminder-3",
"b2c-rndg-continued-lite-prepay-payment-reminder-4",
"b2c-rndg-continued-lite-prepay-payment-reminder-5"
]);

export type RNDGContinuedLitePrepayPaymentRemindersEmailType = z.infer<typeof RNDGContinuedLitePrepayPaymentRemindersEmailTypeEnum
>;

export const RNDGContinuedLitePostPayPaymentRemindersEmailTypeEnum = z.enum([
"b2c-rndg-continued-lite-postPay-payment-reminder-1",
"b2c-rndg-continued-lite-postPay-payment-reminder-2",
"b2c-rndg-continued-lite-postPay-payment-reminder-3",
"b2c-rndg-continued-lite-postPay-payment-reminder-4",
"b2c-rndg-continued-lite-postPay-payment-reminder-5"
]);

export type RNDGContinuedLitePostPayPaymentRemindersEmailType = z.infer<typeof RNDGContinuedLitePostPayPaymentRemindersEmailTypeEnum
>;

export const RNDGContinuedLitePrepayPaymentReminderVarsSchema = z.object({
  firstName:z.string(),
  lastName:z.string(),
  requestType: z.string(),
  requestId: z.string(),
  propertyAddress:z.string(),
  paymentLink:z.string(),
});


export const RNDGLiteInitialAssessmentAvailableReminderSchema = z.object({
	firstName:z.string(),
	lastName:z.string(),
	requestType: z.string(),
	requestId: z.string(),
	propertyAddress:z.string(),
	cancelRequestOrRemindersLink:z.string(),
	linkToFullQuestionnaire:z.string(),
	rulYearRange: z.string(),
	maxDepreciation: z.string(),
	requestGrossPrice:z.string(),
	requestNetPrice:z.string(),
});


export const PostPayInitialPaymentReminderVarsSchema = z.object({
  firstName:z.string(),
  lastName:z.string(),
  requestType: z.string(),
  requestId: z.string(),
  paymentLink:z.string(),
});

export const InitialAssessmentPostPayPaymentEmailVarsSchema = z.object({
	firstName:z.string(),
	lastName:z.string(),
	fileDownloadLink:z.string(),
	requestType: z.string(),
	requestId: z.string(),
	propertyAddress:z.string(),
	paymentLink:z.string(),
});

export const InitialPostPayPaymentReceivedEmailVarsSchema = z.object({
	firstName:z.string(),
	lastName:z.string(),
	requestType: z.string(),
	requestId: z.string(),
	propertyAddress:z.string(),
	receiptLink:z.string(),
})

export const EmailTemplateDataSchema = z.union([
	z.object({
      type: z.literal("b2c-initial-assessment-postPay"),
      templateVars: z.object({
        firstName:z.string(),
        lastName:z.string(),
        fileDownloadLink:z.string(),
        requestType: z.string(),
        requestId: z.string(),
        requestGrossPrice:z.string(),
        requestNetPrice:z.string(),
        cancelRequestOrRemindersLink: z.string().nullable(),
      }),
    })
  ,
  z.object({
    type: z.literal("initial-assessment-postPay"),
    templateVars: z.object({
      firstName:z.string(),
      lastName:z.string(),
      fileDownloadLink:z.string(),
      requestType: z.string(),
      requestId: z.string(),
      priceListLink:z.string(),
      cancelRequestOrRemindersLink: z.string().nullable(),
    }),
  }),
  z.object({
    type: z.literal("initial-assessment-postPay-payment-email"),
    templateVars: z.object({
      firstName:z.string(),
      lastName:z.string(),
      fileDownloadLink:z.string(),
      requestType: z.string(),
      requestId: z.string(),
      propertyAddress:z.string(),
      loginLink:z.string(),
      paymentLink:z.string(),
    }),
  }),
  /**
   * Initial assessment post pay Payment email schemas
   *
   */
  z.object({
    type: z.literal("b2c-initial-assessment-postPay-payment-email"),
    templateVars: InitialAssessmentPostPayPaymentEmailVarsSchema,
  }),
  // Internal & B2C initial share this template
  z.object({
    type: z.literal("initial-assessment-postPay-payment-reminder-1"),
    templateVars: PostPayInitialPaymentReminderVarsSchema,
  }),
  // Internal & B2C initial share this template
  z.object({
    type: z.literal("initial-assessment-postPay-payment-reminder-2"),
    templateVars: PostPayInitialPaymentReminderVarsSchema,
  }),
  // Internal & B2C initial share this template
  z.object({
    type: z.literal("initial-assessment-postPay-payment-reminder-3"),
    templateVars: PostPayInitialPaymentReminderVarsSchema,
  }),
  // Internal & B2C initial share this template
  z.object({
    type: z.literal("initial-assessment-postPay-payment-reminder-4"),
    templateVars: PostPayInitialPaymentReminderVarsSchema,
  }),
  // Internal & B2C initial share this template
  z.object({
    type: z.literal("initial-assessment-postPay-payment-reminder-5"),
    templateVars: PostPayInitialPaymentReminderVarsSchema,
  }),
  // Internal & B2C initial share this template
  z.object({
    type: z.literal("postPay-payment-received-template"),
    templateVars: InitialPostPayPaymentReceivedEmailVarsSchema
  }),
  z.object({
    type: z.literal("prePay-payment-received-template"),
    templateVars: z.object({
      firstName:z.string(),
      lastName:z.string(),
      requestType: z.string(),
      requestId: z.string(),
      propertyAddress:z.string(),
      receiptLink:z.string(),
    }),
  }),
  z.object({
    type: z.literal("standard-prePay-requests-payment-received-template"),
    templateVars: z.object({
      firstName:z.string(),
      lastName:z.string(),
      requestType: z.string(),
      requestId: z.string(),
      propertyAddress:z.string(),
      receiptLink:z.string(),
    }),
  }),
  /**
   * Payment Reminder email schemas for without initial assessment pre pay
   *
   */
    // Internal & B2C initial share this template
   z.object({
    type: z.literal("no-initial-assessment-prePay-pay"),
    templateVars: z.object({
      firstName:z.string(),
      lastName:z.string(),
      requestType: z.string(),
      requestId: z.string(),
      propertyAddress:z.string(),
      paymentLink:z.string(),
    }),
  }),
    // Internal & B2C initial share this template
    z.object({
      type: z.literal("no-initial-assessment-prePay-payment-reminder-1"),
      templateVars: z.object({
        firstName:z.string(),
        lastName:z.string(),
        requestType: z.string(),
        requestId: z.string(),
        propertyAddress:z.string(),
        paymentLink:z.string(),
      }),
    }),
     // Internal & B2C initial share this template
     z.object({
      type: z.literal("no-initial-assessment-prePay-payment-reminder-2"),
      templateVars: z.object({
        firstName:z.string(),
        lastName:z.string(),
        requestType: z.string(),
        requestId: z.string(),
        propertyAddress:z.string(),
        paymentLink:z.string(),
      }),
    }),
    // Internal & B2C initial share this template
    z.object({
      type: z.literal("no-initial-assessment-prePay-payment-reminder-3"),
      templateVars: z.object({
        firstName:z.string(),
        lastName:z.string(),
        requestType: z.string(),
        requestId: z.string(),
        propertyAddress:z.string(),
        paymentLink:z.string(),
      }),
    }),
    z.object({
      type: z.literal("no-initial-assessment-prePay-payment-reminder-4"),
      templateVars: z.object({
        firstName:z.string(),
        lastName:z.string(),
        requestType: z.string(),
        requestId: z.string(),
        propertyAddress:z.string(),
        paymentLink:z.string(),
      }),
    }),
    z.object({
      type: z.literal("no-initial-assessment-prePay-payment-reminder-5"),
      templateVars: z.object({
        firstName:z.string(),
        lastName:z.string(),
        requestType: z.string(),
        requestId: z.string(),
        propertyAddress:z.string(),
        paymentLink:z.string(),
      }),
    }),

	z.object({
		type: z.literal("no-initial-assessment-prePay-payment-received"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			requestType: z.string(),
			requestId: z.string(),
			propertyAddress: z.string(),
			paymentLink: z.string(),
		}),
	}),
	z.object({
		type: z.literal("no-initial-assessment-prePay-full-appraisal"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			requestType: z.string(),
			requestId: z.string(),
			propertyAddress: z.string(),
			loginLink: z.string(),
			fileDownloadLink: z.string(),
		}),
	}),
	z.object({
		type: z.literal("new-initial-request-email-template"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			requestType: z.string(),
			requestId: z.string(),
			linkToRequest: z.string(),
			initialAssessmentDesire: z.string(),
			paymentType: z.string(),
			emailSubject: z.string(),
			viewing: z.string(),
		}),
	}),
	z.object({
		type: z.literal("request-received-no-initial-assessment"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			requestType: z.string(),
			requestId: z.string(),
			propertyAddress: z.string(),
			paymentLink: z.string(),
		}),
	}),
	z.object({
		type: z.literal("request-received-standard-prepay"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			requestType: z.string(),
			requestId: z.string(),
			propertyAddress: z.string(),
			paymentLink: z.string(),
		}),
	}),
	z.object({
		type: z.literal("request-received-standard-prepay"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			requestType: z.string(),
			requestId: z.string(),
			propertyAddress: z.string(),
			paymentLink: z.string(),
		}),
	}),
	z.object({
		type: z.literal("standard-prePay-request-in-progress"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			requestType: z.string(),
			requestId: z.string(),
			propertyAddress: z.string(),
		}),
	}),
	z.object({
		type: z.literal("standard-prePay-full-appraisal"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			requestType: z.string(),
			requestId: z.string(),
			propertyAddress: z.string(),
			loginLink: z.string(),
			fileDownloadLink: z.string(),
		}),
	}),
	z.object({
		type: z.literal("b2c-standard-prePay-full-appraisal"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			requestType: z.string(),
			requestId: z.string(),
			propertyAddress: z.string(),
			fileDownloadLink: z.string(),
		}),
	}),
	z.object({
		type: z.literal("std-and-no-assessment-prepay-payment-reminder-1"),
		templateVars: PrepayStandardNoInitialVarsSchema,
	}),
	z.object({
		type: z.literal("std-and-no-assessment-prepay-payment-reminder-2"),
		templateVars: PrepayStandardNoInitialVarsSchema,
	}),
	z.object({
		type: z.literal("std-and-no-assessment-prepay-payment-reminder-3"),
		templateVars: PrepayStandardNoInitialVarsSchema,
	}),
	z.object({
		type: z.literal("std-and-no-assessment-prepay-payment-reminder-4"),
		templateVars: PrepayStandardNoInitialVarsSchema,
	}),
	z.object({
		type: z.literal("std-and-no-assessment-prepay-payment-reminder-5"),
		templateVars: PrepayStandardNoInitialVarsSchema,
	}),

	z.object({
		type: z.literal("new-account-request-received"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
		}),
	}),
	z.object({
		type: z.literal("new-company-registration-admin-email"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			companyRequestLink: z.string(),
			companyName: z.string(),
		}),
	}),
	z.object({
		type: z.literal("user-account-created"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			loginLink: z.string(),
			onboardingLink: z.string(),
		}),
	}),
	z.object({
		type: z.literal("new-account-request-denied"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
		}),
	}),
	z.object({
		type: z.literal("new-entity-invite"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			inviteLink: z.string(),
		}),
	}),
	z.object({
		type: z.literal("new-sub-user-invite"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			inviteLink: z.string(),
		}),
	}),
	z.object({
		type: z.literal("new-main-user-invite"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			inviteLink: z.string(),
			userName: z.string(),
			entityName: z.string(),
		}),
	}),
	z.object({
		type: z.literal("new-appraiser-admin-invite"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			inviteLink: z.string(),
			appraiserName: z.string(),
		}),
	}),
	z.object({
		type: z.literal("password-reset-email"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			passwordResetLink: z.string(),
		}),
	}),
	z.object({
		type: z.literal("password-change-success-email"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
		}),
	}),
	z.object({
		type: z.literal("request-received-email-template"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			requestType: z.string(),
			requestId: z.string(),
			propertyAddress: z.string(),
		}),
	}),
	z.object({
		type: z.literal("new-request-created-admin-email"),
		templateVars: z.object({
			requestType: z.string(),
			requestId: z.string(),
			propertyAddress: z.string(),
			requestOwnerName: z.string().nullable(),
			requestOwnerEntityName: z.string().nullable(),
			linkToRequest: z.string(),
			requestExportDownloadLink: z.string(),
			emailSubject: z.string(),
		}),
	}),
	z.object({
		type: z.literal("full-appraisal-email-template"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			requestType: z.string(),
			requestId: z.string(),
			propertyAddress: z.string(),
			linkToRequest: z.string().nullable(),
			fileDownloadLink: z.string(),
		}),
	}),
	z.object({
		type: z.literal("manual-postPay-full-appraisal-with-no-payment-link"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			requestType: z.string(),
			requestId: z.string(),
			propertyAddress: z.string(),
			linkToRequest: z.string().nullable(),
			fileDownloadLink: z.string(),
		}),
	}),
	z.object({
		type: z.literal("prepay-with-assessment-payment-email-template"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			requestType: z.string(),
			requestId: z.string(),
			propertyAddress: z.string(),
			paymentLink: z.string(),
			fileDownloadLink: z.string(),
      cancelRequestOrRemindersLink:z.string(),
		}),
	}),
	z.object({
		type: z.literal("request-in-progress-email-template"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			requestType: z.string(),
			requestId: z.string(),
			propertyAddress: z.string(),
			emailSubject: z.string(),
		}),
	}),
	z.object({
		type: z.literal("initial-assessment-prepay-payment-reminder-1"),
		templateVars: PrepayInitialPaymentReminderVarsSchema,
	}),
	z.object({
		type: z.literal("initial-assessment-prepay-payment-reminder-2"),
		templateVars: PrepayInitialPaymentReminderVarsSchema,
	}),
	z.object({
		type: z.literal("initial-assessment-prepay-payment-reminder-3"),
		templateVars: PrepayInitialPaymentReminderVarsSchema,
	}),
	z.object({
		type: z.literal("initial-assessment-prepay-payment-reminder-4"),
		templateVars: PrepayInitialPaymentReminderVarsSchema,
	}),
	z.object({
		type: z.literal("initial-assessment-prepay-payment-reminder-5"),
		templateVars: PrepayInitialPaymentReminderVarsSchema,
	}),
	z.object({
		type: z.literal("request-transferred-to-user"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			requestType: z.string(),
			requestId: z.string(),
		}),
	}),
	z.object({
		type: z.literal("order-appraisal-after-initial-assessment"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			entityName: z.string().nullable(),
			requestType: z.string(),
			requestId: z.string(),
			linkToRequest: z.string(),
		}),
	}),
	z.object({
		type: z.literal("order-appraisal-after-initial-assessment-received"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			requestType: z.string(),
			requestId: z.string(),
			propertyAddress: z.string(),
		}),
	}),
    z.object({
      type: z.literal("cancel-request-after-initial-assessment"),
      templateVars: z.object({
        firstName:z.string(),
        lastName:z.string(),
        requestType: z.string(),
        requestId: z.string(),
        linkToRequest:z.string(),
      }),
    }),
	z.object({
		type: z.literal("platform-fee-invoice"),
		templateVars: z.object({
			requestId: z.string(),
			invoiceLink: z.string(),
			clientInvoiceNumber: z.string(),
		}),
	}),
	// LITE VERSION
	z.object({
		type: z.literal("b2c-rndg-lite-new-request-admin-email"),
		templateVars: z.object({
			firstName:z.string(),
			lastName:z.string(),
			requestType: z.string(),
			requestId: z.string(),
			propertyAddress: z.string(),
			linkToRequest: z.string(),
			rulYearRange: z.string(),
			requestVariant: z.string(),
			linkToRULResults: z.string(),
		}),
	}),
	z.object({
		type: z.literal("b2c-rndg-lite-initial-assessment-available"),
		templateVars: z.object({
			firstName:z.string(),
			lastName:z.string(),
			linkToFullQuestionnaire:z.string(),
			propertyAddress: z.string(),
			rulYearRange: z.string(),
			maxDepreciation: z.string(),
			requestType: z.string(),
			requestId: z.string(),
			requestGrossPrice:z.string(),
			requestNetPrice:z.string(),
		}),
    }),
	z.object({
      type: z.literal("b2c-rndg-lite-initial-assessment-not-available"),
      templateVars: z.object({
        firstName:z.string(),
        lastName:z.string(),
		propertyAddress: z.string(),
        requestType: z.string(),
        requestId: z.string(),
		linkToFullQuestionnaire:z.string(),
      }),
    }),
	z.object({
		type: z.literal("b2c-rndg-lite-initial-assessment-reminder-1"),
		templateVars: RNDGLiteInitialAssessmentAvailableReminderSchema,
	}),
	z.object({
		type: z.literal("b2c-rndg-lite-initial-assessment-reminder-2"),
		templateVars: RNDGLiteInitialAssessmentAvailableReminderSchema,
	}),
	z.object({
		type: z.literal("b2c-rndg-lite-initial-assessment-reminder-3"),
		templateVars: RNDGLiteInitialAssessmentAvailableReminderSchema,
	}),
	z.object({
		type: z.literal("b2c-rndg-lite-initial-assessment-reminder-4"),
		templateVars: RNDGLiteInitialAssessmentAvailableReminderSchema,
	}),
	z.object({
		type: z.literal("b2c-rndg-lite-initial-assessment-reminder-5"),
		templateVars: RNDGLiteInitialAssessmentAvailableReminderSchema,
	}),
	z.object({
		type: z.literal("b2c-lite-continued-order-confirmation-admin-email"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			entityName: z.string(),
			requestType: z.string(),
			requestId: z.string(),
			propertyAddress: z.string(),
			linkToRequest: z.string(),
			addonServices: z.string(),
			paymentType: z.string(),
		}),
	}),
	z.object({
      type: z.literal("b2c-rndg-lite-prepay-order-received"),
      templateVars: z.object({
      	firstName: z.string(),
		lastName: z.string(),
		requestType: z.string(),
		requestId: z.string(),
		propertyAddress: z.string(),
		paymentLink: z.string(),
      }),
    }),
	z.object({
		type: z.literal("b2c-rndg-continued-lite-prepay-payment-reminder-1"),
		templateVars: RNDGContinuedLitePrepayPaymentReminderVarsSchema,
	}),
	z.object({
		type: z.literal("b2c-rndg-continued-lite-prepay-payment-reminder-2"),
		templateVars: RNDGContinuedLitePrepayPaymentReminderVarsSchema,
	}),
	z.object({
		type: z.literal("b2c-rndg-continued-lite-prepay-payment-reminder-3"),
		templateVars: RNDGContinuedLitePrepayPaymentReminderVarsSchema,
	}),
	z.object({
		type: z.literal("b2c-rndg-continued-lite-prepay-payment-reminder-4"),
		templateVars: RNDGContinuedLitePrepayPaymentReminderVarsSchema,
	}),
	z.object({
		type: z.literal("b2c-rndg-continued-lite-prepay-payment-reminder-5"),
		templateVars: RNDGContinuedLitePrepayPaymentReminderVarsSchema,
	}),
    z.object({
		type: z.literal("b2c-rndg-continued-lite-prepay-payment-received"),
		templateVars: z.object({
			firstName:z.string(),
			lastName:z.string(),
			requestType: z.string(),
			requestId: z.string(),
			propertyAddress:z.string(),
			receiptLink:z.string(),
	}),
  }),
  	z.object({
		type: z.literal("b2c-rndg-lite-postPay-order-received"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			requestType: z.string(),
			requestId: z.string(),
			propertyAddress: z.string(),
		}),
	}),
	z.object({
		type: z.literal("b2c-rndg-continued-lite-postPay-payment-email"),
		templateVars: InitialAssessmentPostPayPaymentEmailVarsSchema,
	}),
	z.object({
		type: z.literal("b2c-rndg-continued-lite-postPay-payment-reminder-1"),
		templateVars: PostPayInitialPaymentReminderVarsSchema,
	}),
	z.object({
		type: z.literal("b2c-rndg-continued-lite-postPay-payment-reminder-2"),
		templateVars: PostPayInitialPaymentReminderVarsSchema,
	}),
	z.object({
		type: z.literal("b2c-rndg-continued-lite-postPay-payment-reminder-3"),
		templateVars: PostPayInitialPaymentReminderVarsSchema,
	}),
	z.object({
		type: z.literal("b2c-rndg-continued-lite-postPay-payment-reminder-4"),
		templateVars: PostPayInitialPaymentReminderVarsSchema,
	}),
	z.object({
		type: z.literal("b2c-rndg-continued-lite-postPay-payment-reminder-5"),
		templateVars: PostPayInitialPaymentReminderVarsSchema,
	}),
	z.object({
		type: z.literal("b2c-rndg-continued-lite-postPay-payment-received"),
		templateVars: InitialPostPayPaymentReceivedEmailVarsSchema
	}),
	// Comment mention notification
	z.object({
		type: z.literal("comment-mention-notification"),
		templateVars: z.object({
			// Canonical vars
			firstName: z.string(),
			lastName: z.string(),
			mentionerName: z.string(),
			linkToEntity: z.string(),
			requestId: z.string(),
			customerName: z.string(),
			propertyAddress: z.string(),
			companyName: z.string(),
			commentText: z.string(),

			// Alias vars to match client copy naming
			admin_name: z.string(),
			TAGGER_admin_name: z.string(),
			request_id: z.string(),
			request_link: z.string(),
			comment_excerpt: z.string(),
			customer_name: z.string(),
			property_address: z.string(),
			company_name: z.string(),
		}),
	}),
	z.object({
		type: z.literal("company-comment-mention-notification"),
		templateVars: z.object({
			entityName: z.string(),
			adminName: z.string(),
			taggerName: z.string(),
			commentExcerpt: z.string(),
			entityLink: z.string(),
		}),
	}),
	// New user remark notification to admins
	z.object({
		type: z.literal("new-user-remark-notification"),
		templateVars: z.object({
			userName: z.string(),
			userEmail: z.string(),
			requestId: z.string(),
			requestType: z.string(),
			submittedRemark: z.string(),
		}),
	}),
	z.object({
		type: z.literal("external-file-upload-link-email"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			requestId: z.string(),
			propertyAddress: z.string(),
			fileUploadLink: z.string(),
		}),
	}),
	z.object({
		type: z.literal("new-external-documents-uploaded-admin-email"),
		templateVars: z.object({
			customerFirstName: z.string(),
			customerLastName: z.string(),
			linkToRequest: z.string(),
			companyName: z.string(),
			requestId: z.string(),
			propertyAddress: z.string(),
			assigneeName: z.string()
		}),
	}),
	z.object({
		type: z.literal("new-reminder-created-admin-notification"),
		templateVars: z.object({
			target: z.string(),
			assignee: z.string(),
			creator: z.string(),
			description: z.string(),
			dueDate: z.string(),
		}),
	}),
	z.object({
		type: z.literal("manual-invoice-and-appraisal"),
		templateVars: z.object({
			firstName: z.string(),
			lastName: z.string(),
			requestId: z.string(),
			propertyAddress: z.string(),
			requestType: z.string(),
			fileDownloadLink: z.string(),
			invoiceDownloadLink: z.string(),
			canLoginToEvalion: z.boolean(),
			loginLink: z.string().nullable()
		}),
	}),
]);

export type EmailTemplateData = z.infer<typeof EmailTemplateDataSchema>;
